import FAQContent from 'sly/agentsPage/components/AgentsContent/FAQSection/FAQContent';

export default function FAQSection() {
  return (
    <div data-tp-id='gen-div-f7b92d79-a586-4455-a2a1-d7ba3192c7e1'>
      <div
        className='rounded rounded-bl-none rounded-br-none border-t border-b-0 border-slate-lighter-90 p-0'
        data-tp-id='gen-div-4ddd2b7e-59cc-4a24-a5dd-a0259bfcd700'
      >
        {/*line height 1.29?*/}
        <div
          className='border-l border-r p-6 pb-0 text-[1.75rem] font-medium leading-[1.29]'
          data-tp-id='gen-div-cc54a82a-8dd7-4bd4-bede-cb71733f6d6a'
        >
          Frequently Asked Questions
        </div>
        <FAQContent />
      </div>
    </div>
  );
}
